import { TreatmentDesign, TreatmentDesignRevisionJudgement, TreatmentDesignRevisionJudgementEditModel } from '../../../core/model';
import { TreatmentTypeOriginalId } from '../../../core/model/treatmentType';
import { TreatmentDesignQCChecklistItem } from '../../qc-checklist/model';

/**
 * Configuration for opening the QC Checklist Dialog.
 */
export interface QCChecklistDialogConfig {
    readonly treatmentId: string;
    readonly designId: number;
    readonly organizationId?: string | null;
    readonly checklistItems: TreatmentDesignQCChecklistItem[];

    // Props for accept/reject operations - same as app-treatment-review-operation inputs
    readonly treatmentTypeId?: TreatmentTypeOriginalId | null;
    readonly designRevisionJudgement?: TreatmentDesignRevisionJudgement | null;
    readonly design?: TreatmentDesign | null;
}

/**
 * Result emitted when the dialog closes.
 */
export interface QCChecklistDialogResult {
    readonly action: 'accept' | 'reject' | 'cancel';
    readonly checklist?: TreatmentDesignQCChecklistItem[] | null;
    readonly rejectReason?: string | null;
    readonly revisionJudgement?: TreatmentDesignRevisionJudgementEditModel | null;
}
